<template>
<div class="dialogEnv">
  <el-form ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-loading="loading">
    <env-form :formItem="env"></env-form>
  </el-form>
</div>
</template>

<script>
import bus from './bus'
import qs from 'qs'
import arrayData from '../assets/javascript/dataProcess'
import envForm from '../assets/components/form'
export default {
  name: "dialogEnv",
  components:{
    envForm
  },
  data() {
    return {
      loading: false,
      disabled: true,
      id: '',
      totalId: '',
      envData: {},
      env: []
    }
  },
  methods: {
    /*数据渲染*/
    dataRender() {
      for (let i = 0; i < this.env.length; i++) {
        for (let key of Object.keys(this.envData)) {
          if (key === this.env[i].name) {
            this.env[i].value = this.envData[key];
          }
        }
      }
    },
    /*数据修改*/
    changeData() {
      let formData = {};
      if (this.env[0].value === '' || this.env[1].value === '' || this.env[2].value === '' || this.env[3].value === '' || this.env[4].value === '') {
        for (let i = 0; i < 5; i++) {
          if (this.env[i].value === "") {
            this.$set(this.env[i], "warning", 1);
            this.$set(this.env[i], "warningMsg", "必填信息不得为空");
          }
        }
      } else {
        for (let i = 0; i < this.env.length; i++) {
          formData[this.env[i].name] = this.env[i].value;
        }
        formData.id = this.envData.id;
        formData.totalId = this.envData.totalId;
        this.loading = true;
        this.$http.put(
            '/environment/environment',
            formData, {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then((res) => {
            this.$message({
              message: "环境信息修改成功",
              type: 'success',
              center: true,
              duration: 1000
            });
            this.$nextTick(
              this.loading = false,
            );
          })
          .catch((err) => {
            console.log(err);
            this.$nextTick(
              this.loading = false,
            );
          });
      }
    }
  },
  created() {
    this.env = arrayData.data3.env;
    /*可以修改*/
    bus.$on("change", () => {
      this.disabled = false;
    });
    /*不可以修改*/
    bus.$on("disable", () => {
      this.disabled = true;
    });
    /*接收数据*/
    bus.$on("env", msg => {
      this.envData = msg;
      this.dataRender();
    });
    /*接收案例编号*/
    bus.$on("caseNumber", msg => {
      this.env[0].value = msg;
    });
  }
}
</script>

<style scoped>
.dialogEnv {
  width: 99%;
  height: 100%;
}

.formMsg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
}

</style>



// WEBPACK FOOTER //
// src/data/dialogEnv.vue